import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const s = r(
  (o, a) => /* @__PURE__ */ e.jsx(
    i,
    {
      ref: a,
      ...o,
      image: (l) => /* @__PURE__ */ e.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 32,
          height: 32,
          fill: "none",
          viewBox: "0 0 32 32",
          ...l,
          children: /* @__PURE__ */ e.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M23.172 6H19a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V8.828l-3.348 3.348c-.34.341-.385.875-.142 1.292A10.95 10.95 0 0 1 24 19c0 6.075-4.925 11-11 11S2 25.075 2 19 6.925 8 13 8c2.017 0 3.907.543 5.532 1.49.417.243.95.199 1.292-.142zM13 12a7 7 0 1 0 0 14 7 7 0 0 0 0-14",
              clipRule: "evenodd"
            }
          )
        }
      )
    }
  )
);
s.displayName = "MaleIcon";
export {
  s as MaleIcon,
  s as default
};
//# sourceMappingURL=index.js.map
